export const _setStudentProfileFilterOptions = (state, action) =>
  action.payload;
